import { UserTestProgress } from "@shared/types/profile.types";
import theme from "@shared/utils/themeColors";
import { Link } from "react-router-dom";
import {
  getStatusBadgeClass,
  getStatusText,
} from "../../../shared/utils/test.utils";

interface UserTestCardProps {
  test: UserTestProgress;
}

const UserTestCard = ({ test }: UserTestCardProps) => {
  <div
    className={`relative p-5 rounded-sm border border-gray-200 dark:border-gray-700/60 ${theme.bg.primary} shadow-sm`}
  >
    {/* Card Content */}
    <div className="flex justify-between items-start space-x-3">
      {/* Left side */}
      <div className="grow">
        {/* Status Badge */}
        <div className="flex items-center space-x-2 mb-2">
          <div
            className={`text-xs inline-flex font-medium rounded-full text-center px-2.5 py-1 ${getStatusBadgeClass(
              test.status
            )}`}
          >
            {getStatusText(test.status)}
          </div>
        </div>

        {/* Test Name */}
        <h3 className={`text-lg font-semibold ${theme.text.primary}`}>
          {test.testName}
        </h3>
      </div>

      {/* Right side */}
      <div className="shrink-0">
        <Link
          to={`/tests/${test.testId}`}
          className={`inline-flex items-center justify-center text-sm font-medium leading-5 rounded-full px-3 py-1 border ${theme.border.primary} hover:border-gray-300 dark:hover:border-gray-600 shadow-sm ${theme.bg.primary} ${theme.text.brand} dark:text-violet-400 hover:text-violet-600 dark:hover:text-violet-300 transition`}
        >
          View Test
        </Link>
      </div>
    </div>
  </div>;

  return (
    <div
      className={`col-span-full sm:col-span-6 xl:col-span-4 ${theme.bg.primary} shadow-sm rounded-xl`}
    >
      <div className="flex flex-col h-full p-5">
        <header>
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <div
                className={`text-xs inline-flex font-medium rounded-full text-center px-2.5 py-1 ${getStatusBadgeClass(
                  test.status
                )}`}
              >
                {getStatusText(test.status)}
              </div>
            </div>
          </div>
        </header>
        <div className="grow mt-2">
          <h2 className="text-lg font-semibold text-slate-800 dark:text-slate-100 mb-1">
            {test.testName}
          </h2>
        </div>
        <footer className="mt-5">
          <div className="flex flex-wrap justify-end items-center">
            <Link
              to={`/tests/${test.testId}/take`}
              className={`text-sm font-medium ${theme.text.link}`}
            >
              Go to Test →
            </Link>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default UserTestCard;
